import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicPageModule } from 'ionic-angular';
import { GdAvatarPageModule } from '../../../../components/gd-avatar/gd-avatar.module';
import { GdxLoadingPageModule } from '../../../../components/gdx-loading/gdx-loading.module';
import { ListMultiAccountPage } from './list-multi-account';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    ListMultiAccountPage,
  ],
  imports: [
    IonicPageModule.forChild(ListMultiAccountPage),
    GdAvatarPageModule,
    FlexLayoutModule,
    GdxLoadingPageModule,
    TranslateModule,
    AngularSvgIconModule
  ],
  exports: [
    ListMultiAccountPage
  ]
})
export class ListMultiAccountPageModule { }



// WEBPACK FOOTER //
// ./src/pages/general/home2/list-multi-account/list-multi-account.module.ts